import lager_822 from './funnels/lager_822';
import lackierer from './funnels/lackierer';
import hermes_915 from './funnels/hermes_915';
import thoni_915 from './funnels/thoni_915';
import lenze_918 from './funnels/lenze_918';

const FUNNEL_CONFIGS = { lager_822, lackierer, hermes_915, thoni_915, lenze_918 };

export default FUNNEL_CONFIGS;
